import * as React from "react";
const SvgFiRrTransporter5 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-transporter-5_svg__a)">
      <path
        fill="#062147"
        d="M24 16.513a1 1 0 0 1-.757.97l-1.418.354-.354 1.418a1 1 0 0 1-1.94 0l-.357-1.43-1.432-.385a1 1 0 0 1 .035-1.94l1.404-.325.351-1.406a1 1 0 0 1 1.94 0l.354 1.418 1.418.354a1 1 0 0 1 .757.97zM5.528 3.697a.75.75 0 0 0 0-1.394L4.22 1.78 3.697.472a.75.75 0 0 0-1.394 0l-.52 1.301-1.299.492A.75.75 0 0 0 .46 3.657l1.318.556.526 1.316a.75.75 0 0 0 1.394 0l.523-1.308zM19 22.02H5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2m-11-10a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zm-1-3h10a1 1 0 1 0 0-2H7a1 1 0 1 0 0 2m3-5h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-transporter-5_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTransporter5;
